import DXFWriter from '@tarikjabiri/dxf';
import { Island, Kitchen } from '@rta/rta-blueprint-library';

import { addMetadata } from './add-metadata';
import { ComponentController } from '@r-core';
import { downloadFile } from './dowload-file';
import { drawVectors } from './draw-vectors';
import { Layer } from '@r-core/types';
import { PADDING_BETWEEN_ROWS } from './constants';
import { renderIslandRow } from './render-island-row';

export const startDrawing = new DXFWriter();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const generateDxfFile = (drawing: DXFWriter, yShift: number, { island, controller, kitchen }: { island: Island; controller: ComponentController; kitchen: Kitchen }): void => {
	// This function is kept for backward compatibility but now delegates to renderIslandRow
	const result = renderIslandRow({ drawing, island, rowYOffset: yShift });
	drawVectors(result.vectors, drawing);
};

export const generateDxfFileInternal = (controller: ComponentController): void => {
	const drawing = new DXFWriter().setUnit(DXFWriter.units.Inches);

	// Setup layers
	drawing.addLayer(Layer.Panel, DXFWriter.colors.White, 'CONTINUOUS');
	drawing.addLayer(Layer.UnderlyingPanel, -DXFWriter.colors.Magenta, 'CONTINUOUS');
	drawing.addLayer(Layer.Overlay, DXFWriter.colors.Green, 'CONTINUOUS');
	drawing.addLayer(Layer.LandingZone, DXFWriter.colors.Blue, 'CONTINUOUS');
	drawing.addLayer(Layer.FinishedEdge, DXFWriter.colors.Yellow, 'CONTINUOUS');
	drawing.addLayer(Layer.Label, DXFWriter.colors.Blue, 'CONTINUOUS');

	const { kitchen } = controller;
	const { islands } = kitchen.design;
	let currentYOffset = 0;

	// Render each island as a row
	islands.children.forEach((island) => {
		const result = renderIslandRow({ drawing, island, rowYOffset: currentYOffset });
		drawVectors(result.vectors, drawing);

		// Move to next row
		currentYOffset += result.rowHeight + PADDING_BETWEEN_ROWS;
	});

	addMetadata(drawing, controller, kitchen);
	downloadFile(drawing.stringify(), `${controller.blueprint.email}-${controller.blueprint.id}`);
};
